import React, { useReducer } from "react"
import { Icon } from "semantic-ui-react"
import SidebarNavLink from "../../../Pages/Sidebar/SidebarNavPanel/SidebarNavLink/SidebarNavLink"
import BifrostFeedBackModal from "./BifrostFeedBackModal/BifrostFeedBackModal"
import BifrostHelpSectionMenu from "./BifrostHelpSectionMenu"

const initialState = {
	toggleMenu: false,
	openFeedbackModal: false,
	openFeedbackGreeting: false
}

const reducer = (state, action) => {
	switch (action.type) {
		case "TOGGLE_MENU":
			return { ...state, toggleMenu: !state.toggleMenu }
		case "SET_FEEDBACK":
			return { ...state, toggleMenu: false, openFeedbackModal: action.payload }
		default:
			return state
	}
}

const BifrostHelpSection = () => {
	const [state, dispatch] = useReducer(reducer, initialState)

	return (
		<>
			<SidebarNavLink
				label={
					<>
						Help
						<Icon name="chevron right" style={{ margin: "0 0 5px 50px" }} />
					</>
				}
				icon={<Icon name="life ring" />}
				onClick={(e) => {
					e.preventDefault()
					dispatch({ type: "TOGGLE_MENU" })
				}}
			/>
			{state.toggleMenu && (
				<>
					<div
						style={{ position: "fixed", top: 0, bottom: 0, right: 0, left: 0 }}
						onClick={() => {
							dispatch({ type: "TOGGLE_MENU" })
						}}
					></div>
					<BifrostHelpSectionMenu
						closeMenu={() => {
							dispatch({ type: "TOGGLE_MENU" })
						}}
						toggleFeedbackModal={(value) => {
							dispatch({ type: "SET_FEEDBACK", payload: value })
						}}
					/>
				</>
			)}
			<BifrostFeedBackModal
				open={state.openFeedbackModal}
				toggleFeedbackModal={(value) => {
					dispatch({ type: "SET_FEEDBACK", payload: value })
				}}
			/>
		</>
	)
}

BifrostHelpSection.propTypes = {}

export default BifrostHelpSection
